import { TranslateService } from "@ngx-translate/core";

import { Driver } from "@commons/models/domain/Driver";
import { DriverLicesnseStatus } from "@src/app/enum/driver-license.enum";

export function driverLicenseToText(worker: Driver, translateService: TranslateService): string {
  const { LS: status, L: licenseNumber } = worker;

  if (licenseNumber) {
    if (status === DriverLicesnseStatus.NotCheckedYet) {
      return translateService.instant('driverLicenseStatus.notCheckedYet');
    }
    else if (status === DriverLicesnseStatus.Valid) {
      return translateService.instant('driverLicenseStatus.active');
    }
    else if (status === DriverLicesnseStatus.InsufficientData) {
      return translateService.instant('driverLicenseStatus.unknowError');
    }
    else if (status === DriverLicesnseStatus.Invalid) {
      return translateService.instant('driverLicenseStatus.suspended');
    }
    else if (status === DriverLicesnseStatus.DocumentNotFound) {
      return translateService.instant('driverLicenseStatus.noData');
    }
    else if (status === DriverLicesnseStatus.UnknownError) {
      return translateService.instant('driverLicenseStatus.unknowError');
    }
  }
  return '-';
}
